<style>
  .el-table .warning-row {
    background: oldlace;
  }
  .el-table .success-row {
    background: #f0f9eb;
  }
  a {
    color: #333333;
    text-decoration: none;
  }
  a:hover{
    color: #1890ff;
    text-decoration: none;
  }
.hdNews {
  padding: 12px 24px;
  margin-bottom: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
}
.content_body li {
  line-height: 28px;
  padding: 0 0 0 10px;
}
.clear {
  clear: both;
}
</style>
<template>
<div>
  <HeaderView></HeaderView>
  <NavigateView></NavigateView>
  <BannerView></BannerView>
    <div v-bind:style="{minHeight: height+'px'}" style="width: 980px; margin: 0 auto;" >
    <template>
      <div class="content_body">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item style="padding-top: 8px;">企业申报</el-breadcrumb-item>
          <el-breadcrumb-item style="padding-top: 8px;">在线预约</el-breadcrumb-item>
        </el-breadcrumb>
        <el-divider content-position="left"></el-divider>
      </div>

        <el-table :data="pageData.data" border style="width: 100%" size="mini" :row-class-name="tableRowClassName"    @cell-mouse-leave="showClickIcon=false">
              <el-table-column fixed label="开始日期" width="120" align='center'>
                <template #default="scope">
                  <i class="el-icon-time"></i>
                  <span style="margin-left: 10px">{{ scope.row.startDateName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="title" label="主题" width="200" align='center'></el-table-column>
              <el-table-column prop="address" label="地址" :show-overflow-tooltip='true' align='center'></el-table-column>
              <el-table-column prop="currentLimit" label="参会人数" :show-overflow-tooltip='true' width="150" align='center'></el-table-column>
              <el-table-column prop="statusName" label="预约状态" :show-overflow-tooltip='true' width="100" align='center'></el-table-column>
              <el-table-column label="操作" width="100" align='center'>
              <template #default="scope">
                <el-button @click="operate = true; handleClick(scope.row, scope.row.fn)" type="text" size="small">{{scope.row.operate}}</el-button>
                <el-button v-if="scope.row.content" @click="operate = false; handleClick(scope.row, scope.row.fn)" type="text" size="small">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @size-change="(val) => handlePagination(null, val, 'pageData')" @current-change="(val) => handlePagination(val, null, 'pageData')" @prev-click="(val) => handlePagination(val, null, 'pageData')" @next-click="(val) => handlePagination(val, null, 'pageData')"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="pageData.pageNo"
            :page-sizes="pageData.pageSizes" :page-size="pageData.pageSize" :total="pageData.total">
          </el-pagination>
    </template>
    </div>

    <el-dialog title="提示" :visible.sync="dialogVisible2" width="600px" top="145px">
    <el-form key="subscribe2" :model="subscribe2" :rules="subscribe2Rules" ref="subscribe2">
      <span v-html="subscribe2.content" style="line-height:26px;"></span>
    </el-form>
    <template #footer>
      <span class="dialog-footer" v-if="operate">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button :loading="submitButtonLoading" type="primary" @click="submitForm('subscribe2')">确 定</el-button>
      </span>
    </template>
  </el-dialog>

    <el-dialog title="请选择时间点" :visible.sync="dialogVisible1" width="35%" top="200px">
      <el-form key="subscribe" :model="subscribe" :rules="subscribeRules" ref="subscribe">
        <el-form-item label="活动名称" :label-width="formLabelWidth">
          <el-input v-model="subscribe.title" autocomplete="off" readonly style="width: 95%"></el-input>
        </el-form-item>
        <el-form-item label="预约时间" :label-width="formLabelWidth" prop="configId">
          <el-select v-model="subscribe.configId" placeholder="请选择" style="width: 95%">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :disabled="item.disabled" :value="item.value"></el-option>
        </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible1 = false">取 消</el-button>
          <el-button :loading="submitButtonLoading" type="primary" @click="submitForm('subscribe')">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  <FooterView></FooterView>
</div>

</template>
<script>
  export default {
    name: 'OnlineMeeting',
    data(){
      return {
        active: 0,
        height: 0,
        operate: false,
        captchaUrl: '',
        dialogVisible1: false,
        dialogVisible2: false,
        dialogApplyVisible: false,
        submitButtonLoading: false,
        formLabelWidth: '80px',
        labelWidth100: '100px',
        labelWidth120: '120px',
        subscribe: {
          title: '',
          configId: null,
          meetingId: '',
          content: '',
        },
        subscribe2: {
          title: '',
          meetingId: '',
          content: '',
        },
        subscribeRules: {
          configId: [
            { required: true, message: '请选择预约场次！', trigger: 'blur' },
          ],
          meetingId: [
            { required: true, message: '请刷新页面后重新预约！', trigger: 'blur' },
          ],
        },
        subscribe2Rules: {
          meetingId: [
            { required: true, message: '请刷新页面后重新预约！', trigger: 'blur' },
          ],
        },
        options: [],
        pageData: {
          data: [],
          total: 0,
          pageNo: 1,
          pageSize: 10,
          pageSizes: [10, 20, 50, 100],
          fn: 'getMeeting',
        },
      };
    },
    mounted(){
      // sessionStorage['/onlinemeeting'] = true;
      if(!sessionStorage[this.$route.path]){
        window.location.href = process.env.VUE_APP_API_URL;
      }
      //动态设置内容高度 让footer始终居底   header+footer的高度是100
      this.height = document.documentElement.clientHeight - 350;
      //监听浏览器窗口变化　
      window.onresize = ()=> {this.height = document.documentElement.clientHeight - 350}
    },
    created() {
      this.getMeeting();
    },
    watch:{},
    methods: {
      handleClick(tab, event){
        if(this[tab.name]){
          this[tab.name].call();
        }else if(this[event]){
          this[event].call(this, tab);
        }
      },
      tableRowClassName({row, rowIndex}){
        if(row.meetingCount){
          return 'success-row';
        }
        if(1 == row.status){
          return 'info-row';
        }
        return '';
      },
      getRowKeys(row) {
        return row.id
      },
      digit: function(num, length){
        var str = '';
        num = String(num);
        length = length || 2;
        for(var i = num.length; i < length; i++){
          str += '0';
        }
        return num < Math.pow(10, length) ? str + (num|0) : num;
      },
      toDateString: function(time, format){
        var that = this
        ,date = new Date(time || new Date())
        ,ymd = [
          that.digit(date.getFullYear(), 4)
          ,that.digit(date.getMonth() + 1)
          ,that.digit(date.getDate())
        ]
        ,hms = [
          that.digit(date.getHours())
          ,that.digit(date.getMinutes())
          ,that.digit(date.getSeconds())
        ];
        format = format || 'yyyy-MM-dd HH:mm:ss';
        return format.replace(/yyyy/g, ymd[0])
        .replace(/MM/g, ymd[1])
        .replace(/dd/g, ymd[2])
        .replace(/HH/g, hms[0])
        .replace(/mm/g, hms[1])
        .replace(/ss/g, hms[2]);
      },
      submitForm(formName) {
        this.submitButtonLoading = true;
        this.$refs[formName].validate((valid) => {
          if(valid){
            let d = this[formName];
            var objson = {meetingId: d.meetingId, configId: d.configId};
            //Object.assign(objson, d);
            this.$api.meetingApi.submitSubscribe(objson).then(response => {
              this.submitButtonLoading = false;
              if(response.status === 200){
                if(response.data.code === 200){
                  this.dialogVisible1 = false;
                  this.dialogVisible2 = false;
                  this.$message({ message: response.data.data, offset: 200, type: 'success' });
                  setTimeout(()=>{
                    this.getMeeting();
                  }, 500)
                }else{
                  this.$message({ message: response.data.data, offset: 200, type: 'error' });
                }
              }else{
                this.$message.error(`服务忙，请稍后再试`);
              }
            }).catch(error => {
              this.submitButtonLoading = false;
            });
          } else {
            this.submitButtonLoading = false;
            return false;
          }
        });
      },
      getMeeting: function(){
        this.submitButtonLoading = true;
        this.$api.meetingApi.getMeeting({ queryStatus: '', typeId: '', pageNo: this.pageData.pageNo, pageSize: this.pageData.pageSize }).then(response => {
          this.submitButtonLoading = false;
          if(response.status === 200){
            if(response.data.code === 200){
              this.pageData.data = [];
              JSON.parse(response.data.data).forEach((d, index, arr)=>{
                d.fn = 'goSubscribe';
                d.startDateName = this.toDateString(d.startDate.time, 'yyyy-MM-dd'); // d.startDate.substr(0, 10);
                d.currentLimit = `${d.limit}人（已${d.type.operate}${d.current}人）`;
                if(d.expire){
                  d.statusName = `${d.type.operate}截止`;
                }else{
                  if(d.meetingCountId && d.meetingCount){
                    if(1 === d.type.id){
                      let startTime = 10*24*60*60*1000 + d.meetingCount.config.startTime.time, endTime = startTime + d.meetingCount.config.minuteStep * 60 * 1000;
                      let label = `${this.toDateString(startTime, 'HH:mm')}至${this.toDateString(endTime, 'HH:mm')}`;
                      d.statusName = `已${d.type.operate}${label}场次`;
                    }else{
                      d.statusName = `已${d.type.operate}`;
                    }
                  }else{
                    d.statusName = `可${d.type.operate}`;
                    d.operate = d.type.operate;
                  }
                }
                this.pageData.data.push(d);
              });
              this.pageData.total = response.data.count;
            }else{
              callback(new Error(response.data.msg));
            }
          }else{
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      },
      getMeetingConfig: function(d){
        this.$api.meetingApi.getMeetingConfig({ meetingId: d['id'], typeId: d['type']['id'] }).then(response => {
          this.submitButtonLoading = false;
          if(response.status === 200){
            if(response.data.code === 200){
              console.info(response.data)
              this.options = [];
              JSON.parse(response.data.data).forEach((d, index, arr) => {
                let startTime = 10*24*60*60*1000 + d.startTime.time, endTime = startTime + d.minuteStep * 60* 1000;
                let label = `${this.toDateString(startTime, 'HH:mm')}至${this.toDateString(endTime, 'HH:mm')}`;
                if(d.expire){
                  d.label = label + `场 已约满`;
                  d.disabled = true;
                }else{
                  d.disabled = false;
                  d.label = label + `场 已预约 ` + d.current + `/` + d.limit;
                }
                d.value = d.id;
                this.options.push(d);
              });
            }else{
              callback(new Error(response.data.msg));
            }
          }else{
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      },
      handlePagination(pageNo, pageSize, obj){
        if(this[obj] && typeof this[obj] !== 'function'){
          if(pageNo){
            this[obj].pageNo = pageNo;
          }
          if(pageSize){
            this[obj].pageSize = pageSize;
          }
          this[this[obj].fn] && this[this[obj].fn]();
        }
      },
      toDateString: function(time, format){
        let date = new Date(time || new Date())
        ,ymd = [this.digit(date.getFullYear(), 4), this.digit(date.getMonth() + 1), this.digit(date.getDate())]
        ,hms = [this.digit(date.getHours()), this.digit(date.getMinutes()), this.digit(date.getSeconds())];
        format = format || 'yyyy-MM-dd HH:mm:ss';
        return format.replace(/yyyy/g, ymd[0]).replace(/MM/g, ymd[1]).replace(/dd/g, ymd[2]).replace(/HH/g, hms[0]).replace(/mm/g, hms[1]).replace(/ss/g, hms[2]);
      },
      page: function(){
        this.submitButtonLoading = true;
        let { pageNo, pageSize } = this.queryform;
        this.$api.meetingApi.guestbookPage({ pageNo, pageSize}).then(response => {
          this.submitButtonLoading = false;
          if(response.status === 200){
            if(response.data.code === 200){
              this.queryform.data = [];
              JSON.parse(response.data.data).forEach((d, index, arr)=>{
                if(d.confirmed){
                  d.fn = 'true';
                  d.btnType = 'text';
                  d.operate = '已报名';
                }
                this.queryform.data.push(d);
              });
              this.queryform.total = response.data.count;
            }else{
              callback(new Error(response.data.msg));
            }
          }else{
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      },
      goSubscribe(d){
        this.submitButtonLoading = false;
        this.subscribe = {};
        console.log(d)
        if(1 === d['type']['id']){
          //现场递交材料按时间段预约
          this.dialogVisible1 = true;
          this.subscribe.meetingId = d.id;
          this.subscribe.title = d.title;
          this.getMeetingConfig(d);
        }else if(2 === d['type']['id']){
          //直接预约，不作人数限制
          this.dialogVisible2 = true;
          this.subscribe2.meetingId = d.id;
          this.subscribe2.title = d.title;
          this.subscribe2.content = d.content;
        }
      },
      clearValidate(formName){
        this.$refs[formName].clearValidate();
      },
      changeCaptcha: function() {
        this.captchaUrl = this.getCaptchaUrl();
      },
      getCaptchaUrl: function() {
        this.form.captcha = '';
        return process.env.VUE_APP_API_URL+'captcha.svl?d='+new Date().getTime()
      },
      goLogin() {
        this.$message({ message: '登录过期，请重新登录账户！', offset: 200, type: 'error' });
        setTimeout(() => {
          this.submitButtonLoading = false;
          window.location.href = process.env.VUE_APP_API_URL;
        }, 2000)
      }
    }
  }
</script>
<style>
  .el-dialog__footer {
    text-align: center;
  }
  .el-divider-horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 12px 0;
  }
  .upload-left{
    text-align: left;
  }

  .register-wrapper-div{
    padding-top:10px;
    width: 750px;
    margin: 0 auto;
    background-color: #f8f8f8;
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
  .el-radio{
    margin-right: 0;
  }
  .el-checkbox{
    margin-right: 5px;
  }
  .el-radio--mini.is-bordered {
    margin: 2px 0;
  }
  .el-divider--horizontal {
    margin: 10px 0;
  }
  .el-collapse-item__content{
    padding-bottom: 10px;
  }
  .el-alert--info.is-light{
    width: auto;
    height: 65%;
    margin-right: 15px;
  }
  .el-tag--plain{
    width: 130px;
    text-align: center;
    border: 0px solid #fff;
  }
  .radio-br{
    width: 75%
  }
  .radio-auto{
    float: left;
    margin-right: 10px;
  }
  .assess-score {
    margin-right: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/views/Meeting/OnlineMeeting.vue